export default function MapPage() {
  return (
    <iframe
      src="/legacy/index.html"
      title="iMAP"
      className="block h-full w-full border-0"
      allow="geolocation; clipboard-read; clipboard-write; fullscreen"
    />
  );
}
